import Vue from "vue";
import Router from "vue-router";
import PopDemo from "@/components/PopDemo.vue";
import SignupPage from "@/components/Auth/pages/SignupPage.vue";
import SignupVerifyPage from "@/components/Auth/pages/SignupVerifyPage.vue";
import SocialConfirmPage from "@/components/Auth/pages/SocialConfirmPage.vue";
import AccountExistsPage from "@/components/Auth/pages/AccountExistsPage.vue";
import { PLAN_LOCKED_ROUTES } from "@/components/Auth/plan-gate";
import PlanPickerPage from "@/components/Auth/pages/PlanPickerPage.vue";
import PlanCheckoutPage from "@/components/Auth/pages/PlanCheckoutPage.vue";
import PlanCheckoutReturnPage from "@/components/Auth/pages/PlanCheckoutReturnPage.vue";
import LoginPage from "@/components/Auth/pages/LoginPage.vue";
import LoginCodePage from "@/components/Auth/pages/LoginCodePage.vue";
import ForgotPasswordPage from "@/components/Auth/pages/ForgotPasswordPage.vue";
import ResetPasswordPage from "@/components/Auth/pages/ResetPasswordPage.vue";
import servicePackages from "@/components/service_package_constants";
import RegisterCheckEmail from "@/components/Register/RegisterCheckEmail.vue";
import LegacyChangePasswordPage from "@/components/ResetPasswordPage.vue";
import EmailChangeResult from "@/components/IndependentPages/EmailChangeResult.vue";
import ManageCards from "@/components/ManageCards.vue";
import ChecklistEditorDetail from "@/components/ChecklistEditorDetail.vue"
import UserProfile from "@/components/UserProfile.vue";
import ServicePurchase from "@/components/ServicePurchase.vue";
import ManageSubAccounts from "@/components/ManageSubAccounts.vue";
import Sites from "@/components/SitesListView/Sites.vue";
import NewSite from "@/components/NewSite.vue";
import ListTools from "@/components/SitesSingleView/Tools/ListTools.vue";
import WhiteGloveSitesSingleLayout from "@/components/SitesSingleView/WhiteGlove/Layout.vue";
import OverviewWhiteGlove from "@/components/SitesSingleView/WhiteGlove/Overview.vue";
import ContentPlansWhiteGlove from "@/components/SitesSingleView/WhiteGlove/ContentPlans.vue";
import ContentPlanDetailWhiteGlove from "@/components/SitesSingleView/WhiteGlove/ContentPlanDetail.vue";
import AllContentLayoutWhiteGlove from "@/components/SitesSingleView/WhiteGlove/AllContentLayout.vue";
import AllContentWhiteGlove from "@/components/SitesSingleView/WhiteGlove/AllContent.vue";
import ContentOnlyDetailWhiteGlove from "@/components/SitesSingleView/WhiteGlove/ContentOnlyDetail.vue";
import WinsWhiteGlove from "@/components/SitesSingleView/WhiteGlove/Wins.vue";
import OrderHistoryWhiteGlove from "@/components/SitesSingleView/WhiteGlove/OrderHistory.vue";
import SettingsWhiteGlove from "@/components/SitesSingleView/WhiteGlove/Settings.vue";
import SeoToolsWhiteGlove from "@/components/SitesSingleView/WhiteGlove/SeoTools.vue";
import OrderContentAuditWhiteGlove from "@/components/SitesSingleView/WhiteGlove/OrderContentAudit.vue";
import OrderContentOnlyWhiteGlove from "@/components/SitesSingleView/WhiteGlove/OrderContentOnly.vue";
import ContentOnlyKeywordInsightSingleWhiteGlove from "@/components/SitesSingleView/WhiteGlove/ContentOnlyKeywordInsightSingle.vue";
import PopAuthoritySitesSingleLayout from "@/components/SitesSingleView/PopAuthority/Layout.vue";
import OverviewPopAuthority from "@/components/SitesSingleView/PopAuthority/Overview.vue";
import ContentPlansPopAuthority from "@/components/SitesSingleView/PopAuthority/ContentPlans.vue";
import PackagesPopAuthority from "@/components/SitesSingleView/PopAuthority/Packages.vue";
import DeliverablesPopAuthority from "@/components/SitesSingleView/PopAuthority/Deliverables.vue";
import BoostersPopAuthority from "@/components/SitesSingleView/PopAuthority/Boosters.vue";
import WinsPopAuthority from "@/components/SitesSingleView/PopAuthority/Wins.vue";
import SettingsPopAuthority from "@/components/SitesSingleView/PopAuthority/Settings.vue";
import { familySwitch } from "@/components/SitesSingleView/familySwitch";
import Pages from "@/components/pages/Pages.vue";
import NewPage from "@/components/NewPage.vue";
import PageRuns from "@/components/pageruns/PageRuns.vue";
import PageRun from "@/components/PageRun/Index.vue";
import RerunAnalysis from "@/components/PageRun/RerunAnalysis.vue";
import AdminIndex from "@/components/Admin/index.vue";
import NewBulkRun from "@/components/NewBulkRun.vue";
import WhiteGloveOrdersView from "@/components/WhiteGloveOrdersView.vue";
import GuardDashboard from "@/components/GuardDashboard.vue";
import ReviewOptimizationsDashboard from "@/components/ReviewOptimizationsDashboard.vue";
import AIWriterLogDashboard from "@/components/AIWriterLogDashboard.vue";
import ApiUsageDashboard from "@/components/ApiUsageDashboard.vue";
import AiVisibilityDetail from "@/components/AiVisibility/detail/Index.vue";
import AiVisibilityOverviewTab from "@/components/AiVisibility/detail/tabs/overview/OverviewTab.vue";
import AiVisibilityCitationsTab from "@/components/AiVisibility/detail/tabs/citations/CitationsTab.vue";
import AiVisibilityCompetitorsTab from "@/components/AiVisibility/detail/tabs/competitors/CompetitorsTab.vue";
import AiVisibilityQuestionsTab from "@/components/AiVisibility/detail/tabs/questions/QuestionsTab.vue";
// import BulkRuns from '@/components/BulkRuns'
import CancelSubscriptionConfirm from "@/components/subscription-cancel/CancelSubscriptionConfirm.vue";
import TellUsYourExperience from "@/components/subscription-cancel/TellUsYourExperience.vue";
import SubscriptionCancelSucceed from "@/components/subscription-cancel/SubscriptionCancelSucceed.vue";


// Independent routes which doesn't need auth
import DemoPage from "@/components/IndependentPages/Demo.vue";
import APIDoc from "@/components/IndependentPages/APIDoc.vue";
import UsageStatsPage from "@/components/IndependentPages/UsageStats.vue";
import ExtChecklist from "@/components/IndependentPages/ExtChecklist.vue";
// import FullPageSourceEditor from "@/components/IndependentPages/FullPageSourceEditor.vue";
import FullPageSourceEditorV2 from "@/components/FullPageSourceEditorV2/Index.vue";
import WriterWaitingPage from "@/components/IndependentPages/WriterWaitingPage.vue";
import OpenAITest from "@/components/IndependentPages/OpenAITest.vue";
import UnsubscribeWatchdog from "@/components/IndependentPages/UnsubscribeWatchdog.vue";
import FrontendRouterSpec from "@/components/IndependentPages/FrontendRouterSpec.vue";

import Campaign from '@/components/Campaigns/Index.vue'

// Campaign tabs

import KeywordStrategy from "@/components/Campaigns/keyword-strategy/Index.vue"
import KeywordStrategyListView from "@/components/Campaigns/keyword-strategy/list-view/Index.vue";
import CustomSiloCreateView from "@/components/Campaigns/keyword-strategy/custom-silo/create-view/Index.vue";
import CustomSiloSingleView from "@/components/Campaigns/keyword-strategy/custom-silo/single-view/Index.vue";
import CustomSiloSingleMetricsView from "@/components/Campaigns/keyword-strategy/custom-silo/single-metrics-view/Index.vue";
import OneClickSiloCreateView from "@/components/Campaigns/keyword-strategy/one-click-silo/create-view/Index.vue";
import OneClickSiloSingleView from "@/components/Campaigns/keyword-strategy/one-click-silo/single-view/Index.vue";

import KeywordResearch from "@/components/Campaigns/keyword-research/Index.vue"
import KeywordResearchListView from "@/components/Campaigns/keyword-research/list-view/Index.vue";
import KeywordResearchSingleView from "@/components/Campaigns/keyword-research/single-view/Index.vue";

import KeywordWizard from "@/components/Campaigns/keyword-wizard/KeywordWizard.vue"
import KeywordGap from "@/components/Campaigns/keyword-gap/KeywordGap.vue"
import KeywordTracking from "@/components/Campaigns/keyword-tracking/KeywordTracking.vue"
import Silo from "@/components/Campaigns/silo/Silo.vue"
import QuickContentOrdersTab from "@/components/Campaigns/quick-content-orders/tab/Index.vue"

// Campaign > Keyword Wizard tabs
// import SiteOnlyVoltageComponent from '@/components/Campaigns/keyword-wizard/site-only/SiteOnlyVoltageComponent.vue';
import KeywordOnlyComponent from '@/components/Campaigns/keyword-wizard/new-content/keyword-only/KeywordOnlyComponent.vue';

import PageOpportunityComponent from '@/components/Campaigns/keyword-wizard/existing-content/page-opportunity/PageOpportunityComponent.vue';
import PageVoltageComponent from '@/components/Campaigns/keyword-wizard/existing-content/page-voltage/PageVoltageComponent.vue';
import SupportingKeywordResearch from "@/components/Campaigns/keyword-wizard/existing-content/supporting-keyword-research/SupportingKeywordResearch.vue"

import NewContentView from "@/components/Campaigns/keyword-wizard/new-content/NewContentView.vue";
import ExistingContentView from "@/components/Campaigns/keyword-wizard/existing-content/ExistingContentView.vue";

import ProjectLevelWorkStation from '@/components/Workstation/ProjectLevelWorkStation.vue'
import PageLevelWorkStation from '@/components/Workstation/PageLevelWorkStation.vue'
import ProgressNotes from '@/components/Workstation/ProgressNotes/ProgressNotes.vue'

import store from "@/store";
import _ from "lodash";
import ShareFeedback from "@/components/ShareFeedback.vue";
import AdminOptimizationDetail from "@/components/Admin/AdminOptimizationDetail.vue";


Vue.use(Router);

function legacyServiceToProduct(service) {
  const pkg = Object.values(servicePackages).find((p) => p.urlParam && p.urlParam === service);
  return pkg && pkg.queryParam ? pkg.queryParam.value : "unlimited";
}

const router = new Router({
  linkExactActiveClass: "is-active",
  routes: [
    {
      path: "/",
      name: "Home",
      component: LoginPage,
      beforeEnter(to, from, next) {
        if (store.getters.isAuthenticated) {
          next("/sites");
        } else {
          store.commit("clearStore");
          if (from.name) {
            window.location = "https://pageoptimizer.pro";
          } else {
            next("/login");
          }
        }
      }
    },
    {
      path: "/login",
      name: "Login",
      component: LoginPage
    },
    {
      path: "/login/code",
      name: "LoginCode",
      component: LoginCodePage
    },
    {
      path: "/pop-demo",
      name: "PopDemo",
      component: PopDemo
    },
    {
      path: "/register/verify",
      name: "SignupVerify",
      component: SignupVerifyPage
    },
    {
      path: "/register/social",
      name: "SignupSocialConfirm",
      component: SocialConfirmPage
    },
    {
      // "Change plan" on the signup card: the plan screen before the account exists
      path: "/register/plans",
      name: "SignupPlans",
      component: PlanPickerPage
    },
    {
      path: "/register/exists",
      name: "SignupAccountExists",
      component: AccountExistsPage
    },
    {
      // Legacy /register/<urlParam> links (e.g. /register/yearly-unlimited) keep working as
      // ?product= preselection on the redesigned signup page.
      path: "/register/:service",
      name: "LegacySignupService",
      redirect: (to) => ({
        path: "/register",
        query: { ...to.query, product: legacyServiceToProduct(to.params.service) },
      }),
    },
    {
      path: "/register",
      name: "Signup",
      component: SignupPage
    },
    {
      // In-app plan picker: after the signup code, and later for accounts without a plan.
      path: "/plans",
      name: "Plans",
      component: PlanPickerPage
    },
    {
      path: "/plans/checkout",
      name: "PlanCheckout",
      component: PlanCheckoutPage
    },
    {
      path: "/plans/success",
      name: "PlanCheckoutReturn",
      component: PlanCheckoutReturnPage
    },
    {
      path: "/register-check-email",
      name: "RegisterCheckEmail",
      component: RegisterCheckEmail
    },
    {
      // Legacy temporary-password landing (emails sent before the redesign); delete after 30 days.
      path: "/changepassword",
      name: "UpdatePassword",
      component: LegacyChangePasswordPage
    },
    {
      path: "/reset-password",
      name: "ResetPassword",
      component: ResetPasswordPage
    },
    {
      path: "/forgotpassword",
      alias: "/forgot-password",
      name: "ForgotPassword",
      component: ForgotPasswordPage
    },
    {
      path: "/email-change-result",
      name: "EmailChangeResult",
      component: EmailChangeResult
    },
    {
      path: "/manage-subaccounts",
      name: "ManageSubaccounts",
      component: ManageSubAccounts,
      beforeEnter(to, from, next) {
        if (store.getters.isAgencyUnlimitedUser) {
          next();
        } else {
          next("/");
        }
      }
    },
    {
      path: "/useraccount/:userId/payment-options",
      name: "ManageCards",
      component: ManageCards
    },
    {
      path: "/useraccount/:userId",
      name: "UserProfile",
      component: UserProfile
    },
    {
      path: "/useraccount/:userId/purchase",
      name: "ServicePurchase",
      component: ServicePurchase
    },
    {
      path: "/sites",
      name: "Sites",
      component: Sites,
      beforeEnter(to, from, next) {
        store.commit("setCurrentSiteById", { siteId: -1 });
        next();
      }
    },
    {
      path: "/checklisteditordetail/:siloKeywordId",
      name: "ChecklistEditorDetail",
      component: ChecklistEditorDetail
    },
    {
      path: "/newsite",
      name: "NewSite",
      component: NewSite
    },
    {
      path: "/sites/:siteId/tools",
      name: "ListTools",
      component: ListTools,
    },
    {
      path: "/sites/:siteId/ai-visibility/:trackerId",
      name: "AiVisibilityDetail",
      component: AiVisibilityDetail,
      redirect: { name: "AiVisibilityOverview" },
      children: [
        { path: "overview", name: "AiVisibilityOverview", component: AiVisibilityOverviewTab },
        { path: "citations", name: "AiVisibilityCitations", component: AiVisibilityCitationsTab },
        { path: "competitors", name: "AiVisibilityCompetitors", component: AiVisibilityCompetitorsTab },
        { path: "questions", name: "AiVisibilityQuestions", component: AiVisibilityQuestionsTab },
      ],
    },
    {
      path: "/sites/:siteId/order-content-audit",
      name: "OrderContentAuditWhiteGlove",
      component: OrderContentAuditWhiteGlove,
    },
    {
      // POP Authority packages (standalone page like the order flows; White Glove sessions are sent to the overview)
      path: "/sites/:siteId/packages",
      name: "PopAuthorityPackages",
      component: PackagesPopAuthority,
    },
    {
      path: "/sites/:siteId/order-content-only/insight/:id",
      name: "ContentOnlyKeywordInsightSingleWhiteGlove",
      component: ContentOnlyKeywordInsightSingleWhiteGlove,
    },
    {
      path: "/sites/:siteId/order-content-only",
      name: "OrderContentOnlyWhiteGlove",
      component: OrderContentOnlyWhiteGlove,
    },
    {
      // Single-site pages for the white glove family. Route names are shared by White Glove and
      // POP Authority; familySwitch renders the family's own layout / screen behind the same name.
      path: "/sites/:siteId",
      component: familySwitch({
        name: "SitesSingleLayoutSwitch",
        whiteGlove: WhiteGloveSitesSingleLayout,
        popAuthority: PopAuthoritySitesSingleLayout,
      }),
      redirect: { name: "OverviewWhiteGlove" },
      children: [
        {
          path: "overview",
          name: "OverviewWhiteGlove",
          component: familySwitch({
            name: "SiteOverviewSwitch",
            whiteGlove: OverviewWhiteGlove,
            popAuthority: OverviewPopAuthority,
          }),
        },
        {
          path: "content-plans",
          name: "ContentPlansWhiteGlove",
          component: familySwitch({
            name: "SiteContentPlansSwitch",
            whiteGlove: ContentPlansWhiteGlove,
            popAuthority: ContentPlansPopAuthority,
          }),
        },
        // Shared detail screen; POP Authority mode (package quota, no ordering) is switched inside it
        { path: "content-plans/:siloId", name: "ContentPlanDetailWhiteGlove", component: ContentPlanDetailWhiteGlove },
        {
          path: "all-content",
          component: AllContentLayoutWhiteGlove,
          children: [
            {
              path: "",
              name: "AllContentWhiteGlove",
              component: familySwitch({
                name: "SiteDeliverablesSwitch",
                whiteGlove: AllContentWhiteGlove,
                popAuthority: DeliverablesPopAuthority,
              }),
            },
            {
              path: "quick/:siloId",
              name: "ContentOnlyDetailWhiteGlove",
              component: ContentOnlyDetailWhiteGlove,
            },
          ],
        },
        {
          path: "wins",
          name: "WinsWhiteGlove",
          component: familySwitch({
            name: "SiteWinsSwitch",
            whiteGlove: WinsWhiteGlove,
            popAuthority: WinsPopAuthority,
          }),
        },
        { path: "order-history", name: "OrderHistoryWhiteGlove", component: OrderHistoryWhiteGlove },
        // POP Authority only (the screen sends White Glove sessions back to the overview)
        { path: "boosters", name: "PopAuthorityBoosters", component: BoostersPopAuthority },
        { path: "seo-tools", name: "SeoToolsWhiteGlove", component: SeoToolsWhiteGlove },
        {
          path: "settings",
          name: "SettingsWhiteGlove",
          component: familySwitch({
            name: "SiteSettingsSwitch",
            whiteGlove: SettingsWhiteGlove,
            popAuthority: SettingsPopAuthority,
          }),
        },
      ]
    },
    {
      path: "/sites/:siteId/pages",
      name: "Pages",
      component: Pages
    },
    {
      path: "/sites/:siteId/pages/:pageId",
      name: "PageRuns",
      component: PageRuns
    },
    {
      path: "/sites/:siteId/newpage",
      name: "NewPage",
      component: NewPage
    },
    {
      path: "/sites/:siteId/pages/:pageId/pageruns/:pageRunId",
      name: "PageRun",
      component: PageRun,
      beforeEnter(to, from, next) {
        if (from.params["pageRunId"] !== to.params["pageRunId"]) {
          store.commit("setSeoSourceCode", "");
        }
        next();
      }
    },
    {
      path: '/sites/:siteId/campaign/:campaignId',
      name: 'Campaign',
      component: Campaign,
      redirect: {name: 'keyword-strategy'},  // default tab
      children: [
        {
          path: 'keyword-strategy',
          name: 'keyword-strategy',
          component: KeywordStrategy,
          redirect: {name: 'keyword-strategy-list'},  // named navigation doesn't render the default child without this
          children: [
            {
              path: '',
              name: 'keyword-strategy-list',
              component: KeywordStrategyListView,
            },
            {
              path: 'custom-silo/create',
              name: 'custom-silo-create',
              component: CustomSiloCreateView
            },
            {
              path: 'custom-silo/:id',
              name: 'custom-silo-single',
              component: CustomSiloSingleView
            },
            {
              path: 'custom-silo/:id/metrics/:topicId',
              name: 'custom-silo-single-metrics',
              component: CustomSiloSingleMetricsView
            },
            {
              path: 'one-click-silo/create',
              name: 'one-click-silo-create',
              component: OneClickSiloCreateView
            },
            {
              path: 'one-click-silo/:id',
              name: 'one-click-silo-single',
              component: OneClickSiloSingleView
            },
            {
              path: 'existing-content',
              name: 'existing-content',
              component: ExistingContentView,
              redirect: {name: 'page-opportunity'},  // default tab
              children: [
                {
                  path: 'page-opportunity',
                  name: 'page-opportunity',
                  component: PageOpportunityComponent,
                },
                {
                  path: 'site-only',
                  name: 'site-only',
                  component: PageVoltageComponent,
                },
                {
                  path: 'supporting-keyword-research',
                  name: 'supporting-keyword-research',
                  component: SupportingKeywordResearch,
                },
                {
                  path: 'site-url',
                  name: 'site-url',
                  component: PageVoltageComponent,
                },
              ]
            },
            /*{
              path: ':id',
              name: 'keyword-strategy-single',
              component: KeywordStrategySingleView,
            }*/
          ]
        },
        {
          path: 'keyword-insight',
          name: 'keyword-insight',
          component: KeywordResearch,
          redirect: {name: 'keyword-insight-list'},  // named navigation doesn't render the default child without this
          children: [
            {
              path: '',
              name: 'keyword-insight-list',
              component: KeywordResearchListView,
            },
            {
              path: ':id',
              name: 'keyword-insight-single',
              component: KeywordResearchSingleView,
            }
          ]
        },
        {
          path: 'keyword-wizard',
          name: 'keyword-wizard',
          component: KeywordWizard,
          redirect: {name: 'new-content'},  // default tab
          children: [
            {
              path: 'new-content',
              name: 'new-content',
              component: NewContentView,
              redirect: {name: 'keyword-only'},  // default tab
              children: [
                {
                  path: 'keyword-only',
                  name: 'keyword-only',
                  component: KeywordOnlyComponent,
                },
              ]
            },
            {
              path: 'existing-content',
              name: 'existing-content',
              component: ExistingContentView,
              redirect: {name: 'page-opportunity'},  // default tab
              children: [
                {
                  path: 'page-opportunity',
                  name: 'page-opportunity',
                  component: PageOpportunityComponent,
                },
                {
                  path: 'site-only',
                  name: 'site-only',
                  component: PageVoltageComponent,
                },
                {
                  path: 'supporting-keyword-research',
                  name: 'supporting-keyword-research',
                  component: SupportingKeywordResearch,
                },
                {
                  path: 'site-url',
                  name: 'site-url',
                  component: PageVoltageComponent,
                },
              ]
            },
          ]
        },
        {
          path: 'silo',
          name: 'silo',
          component: Silo,
        },
        {
          path: 'keyword-gap',
          name: 'keyword-gap',
          component: KeywordGap,
        },
        {
          path: 'keyword-tracking',
          name: 'keyword-tracking',
          component: KeywordTracking,
        },
      ]
    },
    {
      path: '/sites/:siteId/quick-content-orders',
      name: 'quick-content-orders',
      component: QuickContentOrdersTab,
    },
    /*{
      path: "/content-editor",
      name: "FullPageSourceEditor",
      component: FullPageSourceEditor
    },*/
    {
      path: "/content-editor",
      name: "FullPageSourceEditor",
      component: FullPageSourceEditorV2
    },
    {
      path: "/ai-writer-waiting/:siteId",
      name: "WriterWaitingPage",
      component: WriterWaitingPage
    },
    {
      path: "/sites/:siteId/pages/:pageId/pageRun/:pageRunId/rerun",
      name: "RerunAnalysis",
      component: RerunAnalysis
    },
    {
      path: "/admin/:userId",
      name: "AdminIndex",
      component: AdminIndex,
      beforeEnter(to, from, next) {
        if (store.getters.isAdmin || store.state.user.isAffiliate) {
          next();
        } else {
          next("/");
        }
      }
    },
    // {
    //   path: '/bulk-runs',
    //   name: 'BulkRuns',
    //   component: BulkRuns,
    //   beforeEnter(to, from, next) {
    //     if (store.getters.isAgencyUnlimitedUser) {
    //       next()
    //     } else {
    //       next('/')
    //     }
    //   }
    // },
    {
      path: "/new-bulk-run",
      name: "NewBulkRun",
      component: NewBulkRun,
      beforeEnter(to, from, next) {
        if (store.getters.isUnlimitedUser || store.state.selectedSubAccountRelation) {
          next();
        } else {
          next("/");
        }
      },
      beforeRouteLeave: function(to, from, next) {
        this.prepareToExit();
        next();
      }
    },
    {
      path: "/guard-dashboard",
      name: "GuardDashboard",
      component: GuardDashboard
    },
    {
      path: "/premium-reviews",
      name: "ReviewOptimizationsDashboard",
      component: ReviewOptimizationsDashboard
    },
    {
      path: "/white-glove-orders",
      name: "WhiteGloveOrdersView",
      component: WhiteGloveOrdersView
    },
    {
      path: "/ai-writer-log",
      name: "AIWriterLogDashboard",
      component: AIWriterLogDashboard
    },
      {
      path: "/optimization-editor-detail",
      name: "AdminOptimizationDetail",
      component: AdminOptimizationDetail
    },
      {
      path: "/feedback",
      name: "ShareFeedback",
      component: ShareFeedback
    },
    {
      path: "/api-usage-dashboard",
      name: "ApiUsageDashboard",
      component: ApiUsageDashboard,
      beforeEnter(to, from, next) {
        if (store.getters.hasApiDashboardAccess) {
          next();
        } else {
          next("/");
        }
      }
    },
    {
      path: "/cancel-subscription-confirm",
      name: "CancelSubscriptionConfirm",
      component: CancelSubscriptionConfirm
    },
    {
      path: "/tell-us-your-experience",
      name: "TellUsYourExperience",
      component: TellUsYourExperience
    },
    {
      path: '/subscription-cancel-succeed',
      name: "SubscriptionCancelSucceed",
      component: SubscriptionCancelSucceed
    },
    {
      path: "/demo",
      name: "DemoPage",
      component: DemoPage
    },
    {
      path: "/demo-for-contentbrief",
      name: "DemoContentBriefPage",
      component: DemoPage
    },
    {
      path: "/api-doc",
      name: "APIDoc",
      component: APIDoc
    },
    {
      path: "/usage-stats",
      name: "UsageStatsPage",
      component: UsageStatsPage
    },
    {
      path: "/ext-checklist",
      name: "ExtChecklist",
      component: ExtChecklist
    },
    {
      path: "/openai-test",
      name: "OpenAITest",
      component: OpenAITest
    },
    {
      path: "/unsubscribe-watchdog",
      name: "UnsubscribeWatchdog",
      component: UnsubscribeWatchdog
    },
    {
      path: "/workstation",
      name: "ProjectLevelWorkStation",
      component: ProjectLevelWorkStation
    },
    {
      path: "/workstation/:siteId/pages/",
      name: "PageLevelWorkStation",
      component: PageLevelWorkStation
    },
    {
      path: "/workstation/:siteId/pages/:pageId/",
      name: "ProgressNotes",
      component: ProgressNotes
      
    },
    {
      path: '/frontend-router-spec',
      name: 'FrontendRouterSpec',
      component: FrontendRouterSpec,
    }

  ]
});

const demoAllowedRoutes = [
  "Sites",
  "ListTools",
  "Pages",
  "NewPage",
  "PageRuns",
  "PageRun",
  "RerunAnalysis",
  "FullPageSourceEditor",
];

// Signup redesign: a no-plan account (user.isPlanRequired) only reads its example project.
// Creation routes open the plan-required modal and the navigation is cancelled (or sent to
// /sites on a hard refresh). Returns true when the navigation was handled.
const guardPlanLockedRoute = (to, from, next) => {
  if (store.getters.isNoPlanUser && PLAN_LOCKED_ROUTES.indexOf(to.name) > -1) {
    store.commit("showPlanRequiredModal", { reason: `route:${to.name}` });
    if (from && from.name) {
      next(false);
    } else {
      next("/sites");
    }
    return true;
  }
  return false;
};

router.beforeEach((to, from, next) => {
  if (
    [
      "Home",
      "Login",
      "PopDemo",
      "Signup",
      "SignupVerify",
      "SignupSocialConfirm",
      "SignupAccountExists",
      "SignupPlans",
      "LegacySignupService",
      "LoginCode",
      "ResetPassword",
      "RegisterCheckEmail",
      "EmailChangeResult",
      "UpdatePassword",
      "ForgotPassword",
      "DemoPage",
      "DemoContentBriefPage",
      "UsageStatsPage",
      "ExtChecklist",
      "FullPageSourceEditor",
      "APIDoc",
      "OpenAITest",
      "UnsubscribeWatchdog",
      "UIPreDesign",
      "FrontendRouterSpec",
    ].indexOf(to.name) > -1
  ) {
    next();
  }  else if (!store.getters.isAuthenticated) {
  store.commit("clearStore");
  const fullPath = to.fullPath;
  next({
    path: "/login",
    query: {
      redirect: fullPath
    }
  });
  } else {
    if (_.isEmpty(store.state.user)) {
      store.commit("showLoading");
      store
        .dispatch("loadUser")
        .then(response => {
          store.commit("setUser", response.data.user);
          store.commit("hideLoading");
          if (guardPlanLockedRoute(to, from, next)) return;
          next();
        })
        .catch(() => {
          store.commit("clearStore");
          next("/login");
        });
    } else {
      if (guardPlanLockedRoute(to, from, next)) return;
      if (!store.getters.isDemoUser || demoAllowedRoutes.indexOf(to.name) > -1) {
        return next();
      } else next("/");
    }
  }
});

export default router;
